import axios from "../../axios.js";
import getToken from "./getToken";
import errorHandler from "./errorHandler";

type ApiOptions = {
  useError?: boolean;
  useSuccess?: boolean;
  useBubbling?: boolean;
  defaultValue?: any;
  headers?: {};
  params?: {};
  responseType?: 'json' | 'blob' | 'arraybuffer' | 'text';  // responseType 추가
};
let externalApiEnabled = false;
if (process.env.NODE_ENV !== 'development') {
  externalApiEnabled = true;
}

export default (method: string, url: string, auth: boolean = false) => {
  method = method.toLowerCase();
  const f = async (
    reqData: object,
    id: string | number | Array<string | number>,
    customOptions: ApiOptions = {}
  ) => {

    // console.log({
    //   method , 
    //   reqData , 
    //   id , 
    //   customOptions , 
    // }) ; 
    // if(url.indexOf('/external-api') >= 0 && !externalApiEnabled){
    //   console.log('개발환경에서 api 요청 방지');
    //   return null
    // }
    let URL;
    if (typeof id === "string" || typeof id === "number") {
      URL = url.split(":id").join(String(id));
    } else if (Array.isArray(id)) {
      for (let i = 0; i < id.length; i++) {
        URL = (URL || url).replace(":id", id[i]);
      }
    } else {
      URL = url;
    }
    // let URL = id ? typeof id === 'string' ?  url.split(":id").join(id)  : Array.isArray(): url;
    let options: ApiOptions = {
      headers: {},
      params: {},
      useError: false,
      useSuccess: false,
      useBubbling: false,
      responseType : 'json',
      ...customOptions,
    };

    // console.log(' - options : ' , options ) ; 
    // console.log( ' customOptions : ' , customOptions ) ; 

    try {
      if (auth) {
        options.headers = { ...options.headers, ...getToken() };
      }
      const args: any = [URL];
      if (["get", "delete"].includes(method)){
        const params = new URLSearchParams();
        for(const data in reqData){
          if(reqData[data] == null ||  reqData[data] == undefined){
            params.append(data, "");   
          }else{
            params.append(data, reqData[data]);
          }
        }
        options.params = params;
      }else{ 
        args.push(reqData);
      }
      args.push(options);
      const res = await axios[method](...args);
      const {data} = res;
      if (data.code < 300) {
        return data.data === null ? options.defaultValue || true : data.data;
      } else if(options.responseType === 'blob'){
        return res;
      }else {
        throw data.message;
      }
    } catch (error) {
      // console.log('Error : ', error)
      error.response.data.error = true;
      return error.response.data;
      // 에러 핸들러 삭제
      // errorHandler(error, options);
      // if (options.defaultValue !== undefined) {
      //   return options.defaultValue;
      // }
    }
  };

  return f;
};
